/** Append `?aff=` (or `&aff=`) when an affiliate code is configured. Skips if already present. */
export function appendAffiliateQueryParam(url: string, affiliateCode?: string | null): string {
  const code = affiliateCode?.trim();
  if (!code) return url;
  try {
    const parsed = new URL(url);
    if (parsed.searchParams.has('aff')) return url;
    parsed.searchParams.set('aff', code);
    return parsed.toString();
  } catch {
    return url;
  }
}
